export function validateDuration(duration: string): string {
  if (!duration) {
    return "";
  }
  if (!/^[-+]?(\d+([.]\d+)?([hsm]|ns|ms|us|µs))+$/gm.test(duration)) {
    return "Must match the Duration Specification. Examples: 5m | 30s | 100ns | 5m30s100ns";
  }
  return "";
}
